<template>
	<LayoutForm>
		<h1 slot="header">Create Document</h1>
		<FormStepNav
            slot="nav"
            :total-steps="totalSteps"
            :current-step="currentStep"
            :completed-step="completedStep"
            :route-base="routeBase"
        />
		<InsightFormStep1 v-if="currentStep === 1" />
		<InsightFormStep2 v-if="currentStep === 2" />
		<InsightFormStep3 v-if="currentStep === 3" />
	</LayoutForm>
</template>

<script>
	import API from '@api';
	import LayoutForm from '@components/Layout/LayoutForm';
	import MultiStepForm from '@components/Form/MultiStepForm';
	import FormStepNav from '@components/Form/FormStepNav';
	import InsightFormStep1 from './Form/InsightFormStep1';
	import InsightFormStep2 from './Form/InsightFormStep2';
	import InsightFormStep3 from './Form/InsightFormStep3';

	export default {
		name: 'InsightForm',
		mixins: [ MultiStepForm ],
		components: {
			InsightFormStep3,
			InsightFormStep2,
			InsightFormStep1,
			FormStepNav,
			LayoutForm,
		},
		data() {
			return {
				totalSteps: 3,
				routeBase: (this.id) ? `/documents/${ this.id }/edit` : '/documents/create',
			}
		},
		methods: {
			fetchResource(id) {
				return API.getInsight(id);
			},
			sanitizeResource(data) {
				data.creator = data.creator.id;
				data.type = data.typeId;

				if(Array.isArray(data.sectors)) {
					data.sectors = data.sectors.map(sector => {
						return sector.id;
					});
				}

				if(Array.isArray(data.attachments)) {
					data.attachments = data.attachments.map(document => {
						this.$store.commit('selectCache/addAttachment', document);
						return document.uuid;
					});
				}

				return data;
			},
		},
	}
</script>
